import { render, staticRenderFns } from "./WebAREmbeds.vue?vue&type=template&id=51636f48&"
import script from "./WebAREmbeds.vue?vue&type=script&lang=js&"
export * from "./WebAREmbeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports